<template>
  <div id="home">
    <div class="content">
      <div class="tab_three">
        <div class="tab_three_con">
          <div class="tab_three_left">
            <p class="left_p">推荐文章</p>
            <img src="../../assets/about/about-c_line.png" alt />
            <ul>
              <li
                class="left_p1"
                v-for="(item,index)  in details"
                :key="index"
                @click="applys(item.id)"
              >
                <span>{{item.title}}</span>
              </li>
            </ul>
          </div>
          <div class="tab_three_right">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom:48px">
              <el-breadcrumb-item :to="{ path: '/about',query:{numm:2} }">关于我们</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/about',query:{numm:2} }">产品动态</el-breadcrumb-item>
              <el-breadcrumb-item>{{lists.title}}</el-breadcrumb-item>
            </el-breadcrumb>
            <ul class="content_left_ul">
              <li class="liss" style="font-size:32px;height:30px">{{lists.title}}</li>
              <li style="color:#9FA19F;height:30px">{{lists.created_at}}</li>
              <li
                style="text-indent:18px;letter-spacing:2px;,"
                v-html="lists.content"
              >{{lists.content}}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
import { getconsulting_details } from "@/config/api";
export default {
  data() {
    return {
      lists: [],
      details: []
    };
  },
  methods: {
    apply() {},
    home() {
      this.$router.push({
        name: "home"
      });
    },
    getlist() {
      var id = this.$route.query.id;
      getconsulting_details({
        consulting_id: id
      }).then(res => {
        this.lists = res.data.content.details;
        this.details = res.data.content.recommend;
      });
    },
    applys(id) {
      this.$router.replace({
        query:{
          id:id
        }
      })
      getconsulting_details({
        consulting_id: id
      }).then(res => {
        this.lists = res.data.content.details;
        this.details = res.data.content.recommend;
      });
    },
    guanyu() {
      this.$router.push({
        name: "about",
        query: {
          numm: 2
        }
      });
    }
  },
  created() {
    this.getlist();
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

#home {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  background: #2b2f33;
  position: fixed;
  z-index: 99;
}

.top_one {
  width: 1200px;
  margin: 0 auto;
}

.img {
  width: 200px;
  height: 40px;
  padding: 10px 57px 15px 0;
  float: left;
}

.top_li li {
  float: left;
  line-height: 65px;
  color: #fff;
  margin-right: 43px;
  cursor: pointer;
}

.top_li li:hover {
  color: #337eff;
}

.top_right {
  float: right;
  line-height: 65px;
}

.button {
  width: 90px;
  height: 33px;
  line-height: 0;
  padding: 0;
}

.bottons {
  background-color: transparent;
  color: #409eff;
  border: 1px solid #409eff;
}

.bottons:hover {
  background-color: #409eff;
}

.add {
  margin-left: 5px;
}

.products,
.productsa {
  position: relative;
}

.product {
  width: 100%;
  position: absolute;
  display: none;
  left: 0;
  z-index: 99;
}

.product_s {
  width: 558px;
  height: 192.3px;
  margin-left: -260px;
}

.products:hover .product {
  display: block;
}

.product-p {
  width: 21px;
  height: 10px;
  margin: 0 auto;
  line-height: 0;
}

.product-div {
  width: 558px;
  height: 182.3px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(225, 230, 240, 1);
  border-radius: 10px;
}

.product-div_p {
  width: 212px;
  height: 182.3px;
  background: #f1f4f8;
  border-radius: 10px 0px 0px 10px;
  float: left;
}

.product-div_p img {
  margin: 20px;
}

.product-div ul {
  width: 346px;
  height: 80px;
  float: left;
}

.product-div ul li {
  margin-left: 38px;
  color: #666666;
  margin-top: 45px;
  line-height: 0;
  font-size: 14px;
  margin-right: 0;
}

.producta {
  width: 100%;
  position: absolute;
  display: none;
  left: 0;
  z-index: 99;
}

.producta_s {
  width: 450px;
  height: 192.3px;
  margin-left: -190px;
}

.productsa:hover .producta {
  display: block;
}

.producta-p {
  width: 21px;
  height: 10px;
  margin: 0 auto;
  line-height: 0;
}

.producta-div {
  width: 450px;
  height: 182.3px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(225, 230, 240, 1);
  border-radius: 10px;
}

.producta-div_p {
  width: 212px;
  height: 182.3px;
  background: #f1f4f8;
  border-radius: 10px 0px 0px 10px;
  float: left;
}

.producta-div_p img {
  margin: 20px;
}

.producta-div ul {
  width: 238px;
  height: 80px;
  float: left;
  margin-top: 26px;
}

.producta-div ul li {
  margin-left: 38px;
  color: #666666;
  margin-top: 45px;
  line-height: 0;
  font-size: 14px;
  margin-right: 0;
}

.content {
  width: 100%;
}

.tab_three_con {
  width: 1200px;
  margin: 100px auto;
}

.tab_three_left {
  width: 240px;
  margin-right: 50px;
  float: left;
}

.left_p {
  font-size: 20px;
  font-weight: 600;
  margin-left: 9px;
  margin-bottom: 6px;
}

.left_p1 {
  margin-top: 14px;
  cursor: pointer;
  border-bottom: 1px solid #ebedf0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.left_p1 span {
  width: 228px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.content_left_ul {
  width: 100%;
  overflow: hidden;
  margin-bottom: 30px;
}

.content_left_ul li {
  font-size: 14px;
  line-height: 25px;
  color: #222222;
  font-family: Microsoft YaHei;
  margin-bottom: 15px;
}

.tab_three_right {
  width: 906px;
  float: left;
}

.liss {
  font-size: 32px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/view/about/details.vue